import React, { useState } from 'react';
import { Card } from 'antd';
import { useRoleGuard } from 'shared/hooks/use-role-guard';
import { UserRole } from 'types/user';
import { DocumentsList } from 'components/documents/documents-list';
import { DocumentsUpload } from 'components/documents/documents-upload';
import { ExpensesListWithCreateButton } from 'components/expenses/expenses-list-with-create-button';
import { InvoicesListWithCreateButton } from 'components/invoices/invoices-list-with-create-button';
import { OrderAdditionalCosts } from 'components/orders/order-additional-costs';
import { OrderCargos } from 'components/orders/order-cargos';
import { EOrderMainTab, type IOrderMainProps } from './types';

export const OrderMain: React.FC<IOrderMainProps> = (props) => {
  const { orderId } = props;
  const [activeTabKey, setActiveTabKey] = useState<EOrderMainTab>(EOrderMainTab.cargos);
  const isInvoicesTabVisible = useRoleGuard([UserRole.admin, UserRole.assistant, UserRole.accountant]);
  const isExpensesTabVisible = useRoleGuard([UserRole.admin, UserRole.assistant, UserRole.accountant]);

  const onTabChange = (key: string) => {
    setActiveTabKey(key as EOrderMainTab);
  };

  const tabListNoTitle = [
    {
      key: EOrderMainTab.cargos,
      label: 'Cargos',
    },
    {
      key: EOrderMainTab.documents,
      label: 'Documents',
    },
    {
      key: EOrderMainTab.additionalCosts,
      label: 'Additional Costs',
    },
    ...(isInvoicesTabVisible
      ? [
          {
            key: EOrderMainTab.invoices,
            label: 'Invoices',
          },
        ]
      : []),
    ...(isExpensesTabVisible
      ? [
          {
            key: EOrderMainTab.expenses,
            label: 'Expenses',
          },
        ]
      : []),
  ];

  const contentListNoTitle: Record<EOrderMainTab, React.ReactNode> = {
    [EOrderMainTab.cargos]: <OrderCargos orderId={orderId} />,
    [EOrderMainTab.documents]: (
      <>
        <DocumentsUpload orderId={orderId} />
        <DocumentsList orderId={orderId} />
      </>
    ),
    [EOrderMainTab.invoices]: isInvoicesTabVisible ? <InvoicesListWithCreateButton orderId={orderId} /> : null,
    [EOrderMainTab.expenses]: isExpensesTabVisible ? <ExpensesListWithCreateButton orderId={orderId} /> : null,
    [EOrderMainTab.additionalCosts]: <OrderAdditionalCosts orderId={orderId} />,
  };

  return (
    <Card style={{ width: '100%' }} tabList={tabListNoTitle} activeTabKey={activeTabKey} onTabChange={onTabChange}>
      {contentListNoTitle[activeTabKey]}
    </Card>
  );
};
